import { AfterViewInit, Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, inject, input, signal } from "@angular/core";
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDropList } from "@angular/cdk/drag-drop";
import { BlogService } from "../services/blog.service";
import { Blog } from "../models/blog";
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  DASHBOARD,
  PAGES,
  PRIORITY_LIST,
  TYPE_LIST,
} from "../constants/constants";
import { CategoryService } from "src/app/services/categories.service";
import { Category } from "src/app/models/category";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { ConfirmationService, MessageService, PrimeTemplate } from "primeng/api";
import { ClientsService } from "src/app/services/clients.service";
import { Clients } from "src/app/models/clients";
import { ComuniService } from "src/app/services/comuni.service";
import { Comuni } from "src/app/models/comuni";
import { Bookings } from "src/app/models/bookings";
import { BookingsService } from "src/app/services/bookings.service";
import * as $ from "jquery";
import { formatDate, SlicePipe } from "@angular/common";
import { Locations } from "src/app/models/locations";
import { Employees } from "src/app/models/employees";
import { WorksService } from "src/app/services/works.service";
import { LocationsService } from "src/app/services/locations.service";
import { EmployeesService } from "src/app/services/employees.service";
import { Works } from "src/app/models/works";
import * as moment from "moment";
import { RoomsService } from "src/app/services/rooms.service";
import { Projects } from "src/app/models/projects";
import { BillingsService } from "src/app/services/billings.service";
import { Billings } from "src/app/models/billings";
import { NgxSpinnerService } from "ngx-spinner";
import { ChartsService } from "src/app/services/charts.service";
import { Charts } from "src/app/models/charts";
import "moment/locale/it";
import { SupportsService } from "src/app/services/supports.service";
import { Supports } from "src/app/models/supports";
moment.locale("it");
import { Subscription } from "rxjs";
import { TasksService } from "src/app/services/tasks.service";
import { Task } from "src/app/models/tasks";
import { TopNavComponent } from "../top-nav/top-nav.component";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Card } from "primeng/card";
import { Tag } from "primeng/tag";
import { TaskDetailsComponent } from "./task-details/task-details.component";
import { Drawer } from "primeng/drawer";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { Editor } from "primeng/editor";
import { Textarea } from "primeng/textarea";
import { InitialsAvatarComponent } from "../components/initials-avatar/initials-avatar.component";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";

import { TPipe } from "../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-tasks",
    templateUrl: "./tasks.component.html",
    imports: [TPipe, TopNavComponent, Bind, ButtonDirective, RouterLink, Card, Tag, CdkDropList, TaskDetailsComponent, Drawer, PrimeTemplate, FormsModule, ReactiveFormsModule, InputText, Select, Editor, Textarea, InitialsAvatarComponent, ConfirmDialog, Toast, SlicePipe, TranslatePipe]
})
export class TasksComponent implements OnInit, OnDestroy {
  private blogService = inject(BlogService);
  private clientsService = inject(ClientsService);
  private bookingsService = inject(BookingsService);
  private billingsService = inject(BillingsService);
  private chartsService = inject(ChartsService);
  private spinner = inject(NgxSpinnerService);
  private fb = inject(UntypedFormBuilder);
  private comuniService = inject(ComuniService);
  private worksService = inject(WorksService);
  private tasksService = inject(TasksService);
  private locationsService = inject(LocationsService);
  private employeesService = inject(EmployeesService);
  private categoryService = inject(CategoryService);
  private cd = inject(ChangeDetectorRef);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);
  private supportsService = inject(SupportsService);
  private route = inject(ActivatedRoute);

  readonly cancel = input<boolean>(false);
  readonly edit = input<boolean>(false);

  calendarOptions: any;
  events: any;
  bookings: any = [];
  booking: Bookings;
  bookingsToday: any = [];
  locations: any = [];
  location: Locations;
  employees: any = [];
  employee: Employees;
  readonly task = signal<Task>(undefined);
  works: any = [];
  work: Works;
  clientsCount: any;
  supports: any = [];
  support: Supports;
  roomsCount: any;
  readonly error = signal<string>(undefined);
  blogForm: UntypedFormGroup;
  readonly typeList = signal<any>(undefined);
  readonly priorityList = signal<any>(undefined);
  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  readonly uploadError = signal<string>(undefined);
  selectedCategories: Category;
  selectedDate: Date;
  date: Date;
  selectedWorks: any[];
  categories: any = [];
  category: Category;
  readonly roomDialogEdit = signal<boolean>(false);
  readonly roomDialogAdd = signal<boolean>(false);
  readonly roomDialogView = signal<boolean>(false);
  bookingsDialog: boolean = false;
  readonly clients = signal<any>([]);
  project_id: string;
  client: Clients;
  comuni: any = [];
  displayEvent: any;
  readonly currentUser = signal<any>(undefined);
  readonly items = signal<any>(undefined);
  bookingsCount: Bookings;
  billingsCount: Billings;
  billingsCountTotal: Billings;
  category_id: string;
  canvas: any;
  ctx: any;
  yAxes: [];
  xAxes: [];
  chartsCount: any;
  chartsCountData: any = [];
  chartsCountDataTotal: string;
  data1 = [];

  readonly donePriorityTasks = signal<Task[]>([]);
  readonly backupDonePriorityTasks = signal<Task[]>([]);
  readonly highPriorityTasks = signal<Task[]>([]);
  readonly backupHighPriorityTasks = signal<Task[]>([]);
  readonly mediumPriorityTasks = signal<Task[]>([]);
  readonly backupMediumPriorityTasks = signal<Task[]>([]);
  readonly lowPriorityTasks = signal<Task[]>([]);
  readonly backupLowPriorityTasks = signal<Task[]>([]);

  busy: Subscription;
  busy1: Subscription;
  busy2: Subscription;
  subscription: Subscription;

  trackByFn(index, item) {
    return item.id;
  }

  myDate = formatDate(new Date(), "dd/MM/yyyy", "en");
  myMonth = formatDate(new Date(), "dd/MM/yyyy", "en");
  valueProcess: number;
  projects: any = [];
  project: Projects;
  availableRooms: any = [];
  readonly selectedRooms = signal<any>([]);
  draggedRoom: any;

  boardData: any = [];
  skills = [];

  taskId: string;

  taskForm = this.fb.group({
    title: ["", Validators.required],
    due_date: [""],
    priority: [""],
    assigned_to: [""],
  });

  constructor() {
    this.typeList.set(TYPE_LIST);
    this.priorityList.set(PRIORITY_LIST);

    this.currentUser.set(JSON.parse(localStorage.getItem("currentUser") || "[]"));
    this.items.set(DASHBOARD);
    this.selectedRooms.set([]);
  }

  ngOnInit() {
    this.getTasks();
    this.getEmployees();
  }

  getEmployees() {
    const params = [];
    this.employeesService.list(params).subscribe((data) => {
      this.clients.set(data);
    });
  }

  goToAddTaskPage() {
    this.roomDialogAdd.set(true);

    this.blogForm = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      description: [""],
      priority: [""],
      employee_id: [""],
    });
  }

  deleteFromLocalData(type, index) {

    this.donePriorityTasks.update((a) => { a.splice(index); return [...a]; });
    this.backupDonePriorityTasks.update((a) => { a.splice(index); return [...a]; });
    this.highPriorityTasks.update((a) => { a.splice(index); return [...a]; });
    this.backupHighPriorityTasks.update((a) => { a.splice(index); return [...a]; });
    this.mediumPriorityTasks.update((a) => { a.splice(index); return [...a]; });
    this.backupMediumPriorityTasks.update((a) => { a.splice(index); return [...a]; });
    this.lowPriorityTasks.update((a) => { a.splice(index); return [...a]; });
    this.backupLowPriorityTasks.update((a) => { a.splice(index); return [...a]; });
  }

  onSubmitEdit(task: Task, index) {
    const formData = new FormData();
    console.log(task);

    const idProject = this.route.snapshot.paramMap.get("project_id");

    formData.append("title", this.blogForm.get("title").value);
    formData.append("priority", this.blogForm.get("priority").value);
    formData.append("description", this.blogForm.get("description").value);
    formData.append("employee_id", this.blogForm.get("employee_id").value);
    formData.append("project_id", idProject);

    const id = task.id;

    if (id) {
      this.busy1 = this.tasksService.update(formData, id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Informazioni",
              detail: "Salvato con sucesso",
            });

            this.deleteFromLocalData(task, index);
            this.roomDialogEdit.set(false);
            this.getTasks();
          }
        },
        (error) => (this.error.set(error))
      );
    } else {
      this.tasksService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Informazioni",
              detail: "Salvato con sucesso",
            });
            this.cd.detectChanges();
          }
        },
        (error) => (this.error.set(error))
      );
    }
  }

  onSubmitAdd(task: Task, index) {
    const formData = new FormData();
    const projectsId = this.route.snapshot.paramMap.get("project_id");
    formData.append("title", this.blogForm.get("title").value);
    formData.append("description", this.blogForm.get("description").value);
    formData.append("priority", this.blogForm.get("priority").value);
    formData.append("employee_id", this.blogForm.get("employee_id").value);
    formData.append("project_id", projectsId);

    this.tasksService.create(formData).subscribe((res) => {
      if (res.status === "error") {
        this.uploadError.set(res.message);
      } else {
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Informazioni",
          detail: "Salvato con sucesso",
        });
        this.deleteFromLocalData(task, index);
        this.getTasks();
      }
    });
  }

  changedNumber(value) {
    this.task().title = value.item.data.title;
  }

  getTasks() {
    const paramsTasks = {
      project_id: this.project.id,
    };

    this.subscription = this.tasksService.list(paramsTasks).subscribe({
      next: (response: any) => {
        if (response.error) {
        } else {
          response.forEach((task) => {
            if (task.priority === "4") {
              this.donePriorityTasks.update((a) => { a.push(task); return [...a]; });
            } else if (task.priority === "3") {
              this.highPriorityTasks.update((a) => { a.push(task); return [...a]; });
            } else if (task.priority === "2") {
              this.mediumPriorityTasks.update((a) => { a.push(task); return [...a]; });
            } else if (task.priority === "1") {
              this.lowPriorityTasks.update((a) => { a.push(task); return [...a]; });
            }
          });
        }
      },
    });

    this.backupDonePriorityTasks.set(this.donePriorityTasks());
    this.backupHighPriorityTasks.set(this.highPriorityTasks());
    this.backupLowPriorityTasks.set(this.lowPriorityTasks());
    this.backupMediumPriorityTasks.set(this.mediumPriorityTasks());
  }

  deleteTask(event, task: Task, index) {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare = " + event.title,
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.busy1 = this.tasksService.delete(event.id).subscribe({
          next: (response: any) => {
            if (response.error) {
            } else {
              this.deleteFromLocalData(task, index);

              this.getTasks();

              this.messageService.add({
                key: "myKey1",
                severity: "warn",
                summary: "Attenzione",
                detail: "Cancellazione avvenuto con successo",
              });
            }
          },
        });
      },
    });
  }

  editItem(task: Task) {
    this.task.set({ ...task });
    const id = task.id;

    if (id) {
      this.tasksService.getId(id).subscribe((res) => {
        this.blogForm.patchValue({
          title: res.title,
          description: res.description,
          priority: res.priority,
          employee_id: res.employee_id,
        });
      });
    } else {
    }

    this.blogForm = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      description: ["", Validators.required],
      priority: ["", Validators.required],
      employee_id: [""],
    });

    this.roomDialogEdit.set(true);
  }

  viewItem(task: Task) {
    this.task.set({ ...task });
    const id = task.id;

    this.tasksService.getId(id).subscribe((data) => {
      (this.task.set(data)), (error) => (this.error.set(error));
    });

    this.roomDialogView.set(true);
  }

  getPerformaceCount(): number {
    let pendingTasks = JSON.parse(
      localStorage.getItem("pendingTaskList")
    ).length;
    let inProgressTasks = JSON.parse(
      localStorage.getItem("inProgressTaskList")
    ).length;
    let completedTasks = JSON.parse(
      localStorage.getItem("completedTaskList")
    ).length;
    return Math.round(
      (completedTasks / (pendingTasks + inProgressTasks + completedTasks)) * 100
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  dropDonePriorityTasksList(event: CdkDragDrop<string[]>) {
    event.item.data.priority = 4;
    this.updatePriority(event);
  }

  dropHighPriorityTasksList(event: CdkDragDrop<string[]>) {
    event.item.data.priority = 3;
    this.updatePriority(event);
  }

  dropMediumPriorityTasksList(event: CdkDragDrop<string[]>) {
    event.item.data.priority = 2;
    this.updatePriority(event);
  }

  dropLowPriorityTasksList(event: CdkDragDrop<string[]>) {
    event.item.data.priority = 1;
    this.updatePriority(event);
  }

  updatePriority(event) {
    const id = event.item.data.id;
    const formData = new FormData();
    formData.set("title", event.item.data.title);
    formData.set("description", event.item.data.description);
    formData.set("employee_id", event.item.data.employee_id);
    formData.set("priority", event.item.data.priority);
    formData.set("project_id", event.item.data.project_id);
    formData.set("id", event.item.data.id);

    this.busy2 = this.tasksService.update(formData, id).subscribe({
      next: (response: any) => {
        if (response.error) {
        } else {
          this.drop(event);
          this.messageService.add({
            key: "myKey1",
            severity: "success",
            summary: "Conferma",
            detail: "Salvato con successo",
          });
        }
      },
    });
  }

  ngOnDestroy() {
    this.busy1 ? this.busy1.unsubscribe() : "";
    this.busy2 ? this.busy2.unsubscribe() : "";
    this.busy ? this.busy.unsubscribe() : "";
    this.subscription.unsubscribe();
  }

  getEmployeeItem(task: Task, id: string) {
    return this.clients().find((item) => item.id === task);
  }
}
